/**
 * Function for populating a button that triggers a drawer component.
 */

import { Button } from 'antd';
import { includes, isEmpty } from 'lodash';
import React, { lazy, Suspense } from 'react';
import { useSelector } from 'react-redux';
import { getUserRole } from '../../store/roles/sagas';
import { populatePopoverContainer } from '../../utils/commonFunctions';

const Drawer = lazy(() => import('antd/lib/drawer'));

interface IProps {
    readonly containerRef?: any;
    readonly allowedRoles?: string[];
    readonly popoverClassName?: string;
    readonly popoverVisible?: boolean;
    readonly popoverTitle?: any;
    readonly popoverContent: any;
    readonly buttonType:
        | 'link'
        | 'default'
        | 'ghost'
        | 'primary'
        | 'dashed'
        | 'danger'
        | undefined;
    readonly buttonClassName?: string;
    readonly buttonContent: any;
    readonly buttonRestProps?: any;
    readonly drawerClosable: boolean;
    readonly maskClosable: boolean;
    readonly drawerWidth?: any;
    readonly onClose?: () => void;
}
const ProtectedDrawerButton: React.FC<IProps> = ({
    containerRef,
    allowedRoles,
    popoverVisible,
    popoverTitle,
    popoverContent,
    buttonType,
    buttonClassName,
    buttonContent,
    buttonRestProps,
    drawerClosable,
    maskClosable,
    drawerWidth,
    onClose,
}: IProps) => {
    const userRole = useSelector(getUserRole);
    if (isEmpty(allowedRoles) || includes(allowedRoles, userRole)) {
        return (
            <>
                <Button
                    type={buttonType}
                    className={buttonClassName}
                    {...buttonRestProps}
                >
                    {buttonContent}
                </Button>
                <Suspense fallback={null}>
                    <Drawer
                        visible={popoverVisible}
                        getContainer={populatePopoverContainer(containerRef)}
                        closable={drawerClosable}
                        maskClosable={maskClosable}
                        title={popoverTitle}
                        width={drawerWidth || 420}
                        className="protected-drawer"
                        onClose={onClose}
                    >
                        {popoverVisible && popoverContent}
                    </Drawer>
                </Suspense>
            </>
        );
    } else {
        return null;
    }
};

export default ProtectedDrawerButton;
